/**
 * Fetch Media Gifts UseCase
 *
 * Paginated read of the "gifts received" list for a piece of content — the
 * content owner's view of who has gifted / unlocked it. Single domain entry
 * point the presentation hook calls; delegates to MediaGiftsService.
 *
 * Mirrors Flutter's content_gifts_bottom_sheet.dart:96-98 call:
 *   GiftsRepository().getMediaGifts(mediaPath, lastFetchedItem,
 *     AppConstants.subscriptionsPagination)
 *
 * Page size: SERVER_FETCH_CONSTANTS.DEFAULT_LIMIT (= 9), which matches Flutter's
 * subscriptionsPagination (lib/domain/constants/app_constants.dart:27). This is a
 * per-screen `limit` on a paginated cursor read — NOT a Firestore `in` /
 * `array-contains-any` chunk size — so the FIRESTORE_WHERE_IN_MAX_VALUES cap rule
 * does not apply (9 sitting below 10 is incidental).
 */

import { mediaGiftsService } from '@/domain/services/mediaGifts/mediaGiftsService';
import type { MediaGiftsPage } from '@/domain/services/mediaGifts/mediaGiftsService';
import { SERVER_FETCH_CONSTANTS } from '@/domain/constants/serverFetchConstants';
import type { PageCursor } from '@/data/types/json';

export class FetchMediaGiftsUseCase {
  constructor(private service = mediaGiftsService) {}

  async execute(
    mediaPath: string,
    cursor?: PageCursor,
    limit: number = SERVER_FETCH_CONSTANTS.DEFAULT_LIMIT,
  ): Promise<MediaGiftsPage> {
    return this.service.fetchMediaGifts(mediaPath, limit, cursor);
  }
}

export const fetchMediaGiftsUseCase = new FetchMediaGiftsUseCase();
